/* unplugin-vue-components disabled */import { render } from "./KilaKilaHeader.vue?vue&type=template&id=4267612a&scoped=true"
import script from "./KilaKilaHeader.vue?vue&type=script&lang=js"
export * from "./KilaKilaHeader.vue?vue&type=script&lang=js"

import "./KilaKilaHeader.vue?vue&type=style&index=0&id=4267612a&scoped=true&lang=css"

import exportComponent from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4267612a"]])

export default __exports__